import 'slick-carousel';

jQuery(document).ready(function($){
    if ( $('.testimonial-slider-block')?.length > 0 ) {
        const slider = $('.testimonial-slider-block .testimonial-slider-block__wrapper');
        const prevButton = slider.parent().find('.prev-btn');
        const nextButton = slider.parent().find('.next-btn');

        slider.slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            prevArrow: prevButton,
            nextArrow: nextButton,
            dots: false,
            fade: true
        });
    }
});